import type { PlateDocumentType } from './PlateDocumentDrawer';

/**
 * RECUR-27304 Delta v3 — Reports (`REPORTS`) and One Pager (`ONE_PAGER`) are
 * the only two Plate document types that show the editor's page-gap overlay
 * (`showPageGaps`) and force the exported PDF to break pages exactly at the
 * page-boundary model's decisions
 * (`injectModelPageBreaks`), instead of leaving Chromium's native pagination
 * in place for every other doc type (Engagement Letter, NDA, consent,
 * application form).
 *
 * `documentType` is widened to `PlateDocumentType | string` so callers that
 * only hold a generic string (e.g. Reports' saved-doc list, which mixes
 * `PlateDocumentType` values with non-Plate doc types like `AICA_REPORT` /
 * `CUSTOM`) can call this without a cast.
 */
export function isPageGapDocumentType(documentType?: PlateDocumentType | string): boolean {
    return documentType === 'REPORTS' || documentType === 'ONE_PAGER';
}
